/**
 * Bilingual lookup for free-form fields stored in DB.
 * DB stores the user-typed value (usually in Arabic). When rendering
 * we map it to the active UI language for full consistency.
 */

const COUNTRY_AR_EN = [
  ["إيطاليا", "Italy"],
  ["فرنسا", "France"],
  ["إسبانيا", "Spain"],
  ["ألمانيا", "Germany"],
  ["المملكة المتحدة", "United Kingdom"],
  ["الولايات المتحدة", "United States"],
  ["كندا", "Canada"],
  ["اليونان", "Greece"],
  ["هولندا", "Netherlands"],
  ["البرتغال", "Portugal"],
  ["بلجيكا", "Belgium"],
  ["سويسرا", "Switzerland"],
  ["النمسا", "Austria"],
  ["السويد", "Sweden"],
  ["النرويج", "Norway"],
  ["الدنمارك", "Denmark"],
  ["تشيكيا", "Czechia"],
  ["بولندا", "Poland"],
  ["المجر", "Hungary"],
  ["أيرلندا", "Ireland"],
  ["أستراليا", "Australia"],
  ["نيوزيلندا", "New Zealand"],
  ["اليابان", "Japan"],
  ["كوريا الجنوبية", "South Korea"],
  ["الصين", "China"],
  ["تركيا", "Türkiye"],
  ["الإمارات", "United Arab Emirates"],
  ["مصر", "Egypt"],
];

const VISA_TYPE_AR_EN = [
  ["سياحة", "Tourism"],
  ["زيارة عائلية", "Family Visit"],
  ["أعمال", "Business"],
  ["علاج", "Medical"],
  ["دراسة", "Study"],
  ["Schengen", "Schengen"],
  ["دعوة", "Invitation"],
  ["دعوة عائلية", "Family Invitation"],
  ["عمل", "Work"],
  ["ترانزيت", "Transit"],
  ["tourist", "Tourism"],
];

const APPLICANT_TYPE_AR_EN = {
  individual: { ar: "فردي", en: "Individual" },
  family: { ar: "عائلي", en: "Family" },
};

const NATIONALITY_AR_EN = {
  saudi: { ar: "سعودي", en: "Saudi" },
  non_saudi: { ar: "غير سعودي", en: "Non-Saudi" },
};

const MARITAL_AR_EN = {
  single: { ar: "أعزب", en: "Single" },
  married: { ar: "متزوج", en: "Married" },
};

const RELATION_AR_EN = {
  spouse: { ar: "زوج/زوجة", en: "Spouse" },
  child: { ar: "ابن/ابنة", en: "Child" },
  parent: { ar: "والد/والدة", en: "Parent" },
  sibling: { ar: "أخ/أخت", en: "Sibling" },
  other: { ar: "أخرى", en: "Other" },
  self: { ar: "صاحب الطلب", en: "Self" },
};

const PAYMENT_STATUS_AR_EN = {
  pending: { ar: "قيد المراجعة", en: "Pending" },
  approved: { ar: "معتمد", en: "Approved" },
  rejected: { ar: "مرفوض", en: "Rejected" },
};

const _build = (pairs) => {
  const map = new Map();
  pairs.forEach(([ar, en]) => {
    map.set(ar.toLowerCase(), en);
    map.set(en.toLowerCase(), ar);
  });
  return { pairs, map };
};

const COUNTRY = _build(COUNTRY_AR_EN);
const VISA = _build(VISA_TYPE_AR_EN);

const _lookup = (val, lang, dict) => {
  if (!val) return "";
  const v = String(val).trim();
  const lower = v.toLowerCase();
  const pair = dict.pairs.find(([ar, en]) =>
    ar.toLowerCase() === lower || en.toLowerCase() === lower
  );
  if (pair) return lang === "en" ? pair[1] : pair[0];
  return v; // unknown — return as-is
};

export const localizeCountry = (val, lang) => _lookup(val, lang, COUNTRY);
export const localizeVisaType = (val, lang) => _lookup(val, lang, VISA);

const _dictLookup = (code, lang, dict) =>
  dict[code] ? dict[code][lang === "en" ? "en" : "ar"] : (code || "");

export const localizeApplicantType = (code, lang) => _dictLookup(code, lang, APPLICANT_TYPE_AR_EN);
export const localizeNationality = (code, lang) => _dictLookup(code, lang, NATIONALITY_AR_EN);
export const localizeMarital = (code, lang) => _dictLookup(code, lang, MARITAL_AR_EN);
export const localizeRelation = (code, lang) => _dictLookup(code, lang, RELATION_AR_EN);
export const localizePaymentStatus = (code, lang) => _dictLookup(code, lang, PAYMENT_STATUS_AR_EN);

export const COUNTRIES_OPTIONS = COUNTRY_AR_EN.map(([ar, en]) => ({ ar, en, value: ar }));
export const VISA_TYPES_OPTIONS = VISA_TYPE_AR_EN.map(([ar, en]) => ({ ar, en, value: ar }));
